import { EActivateInsuranceStep } from '../../types/activateInsurance/step';

export function getSteps(): EActivateInsuranceStep[] {
  return [EActivateInsuranceStep.Insurance, EActivateInsuranceStep.Success];
}
